import { render, staticRenderFns } from "./testeCamera.vue?vue&type=template&id=5777c8d0&"
import script from "./testeCamera.vue?vue&type=script&lang=js&"
export * from "./testeCamera.vue?vue&type=script&lang=js&"
import style0 from "./testeCamera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports